import * as _ from "lodash"


export interface IHasSelected {
    getSelected(): boolean | undefined
    setSelected(selected: boolean): void
}

function hasSelected<TBase extends Constructor>(Base: TBase) {
    return class extends Base implements IHasSelected {
        private selected: boolean | undefined

        constructor(...args: any[]) {
            super(...args);
        }

        public getSelected(): boolean | undefined {
            return this.selected
        }
        public setSelected(selected: boolean): void {
            this.selected = selected
        }
    };
}

export default hasSelected